/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
/* eslint-disable no-return-assign */
/* eslint-disable arrow-body-style */
/* eslint-disable react/button-has-type */
import { useState, useMemo, useEffect, useRef } from "react";

function groupChapters(data) {
  const map = {};
  data.forEach((item) => {
    const key = item.chapter_name.trim().toLowerCase();
    if (!map[key]) {
      map[key] = {
        chapter_name: item.chapter_name.trim(),
        attempts: [],
        total_questions: 0,
        correct_answers: 0,
      };
    }
    map[key].attempts.push(item);
    map[key].total_questions += item.total_questions;
    map[key].correct_answers += item.correct_answers;
  });
 
  return Object.values(map).map((g) => ({
    chapter_name: g.chapter_name,
    total_questions: g.total_questions,
    correct_answers: g.correct_answers,
    percentage: g.total_questions > 0 ? Math.round((g.correct_answers / g.total_questions) * 100) : 0,
    attempt_count: g.attempts.length,
    attempts: g.attempts,
  }));
}
 
function getScoreColor(pct) {
  if (pct === 0) return { bg: "#FEE2E2", text: "#DC2626" };
  if (pct < 30) return { bg: "#FEE2E2", text: "#DC2626" };
  if (pct < 60) return { bg: "#FEF3C7", text: "#D97706" };
  return { bg: "#D1FAE5", text: "#059669" };
}

function useIsMobile(breakpoint = 640) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);
  return isMobile;
}

function ScoreBadge({ value, compact }) {
  const { bg, text } = getScoreColor(value);
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: compact ? "40px" : "52px",
        padding: compact ? "2px 7px" : "3px 10px",
        borderRadius: "6px",
        backgroundColor: bg,
        color: text,
        fontSize: compact ? "11px" : "13px",
        fontWeight: 600,
        letterSpacing: "0.01em",
      }}
    >
      {value}%
    </span>
  );
}
 
function MiniBar({ value }) {
  const { text } = getScoreColor(value);
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <div
        style={{
          flex: 1,
          height: 5,
          borderRadius: 99,
          backgroundColor: "#F3F4F6",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${value}%`,
            height: "100%",
            borderRadius: 99,
            backgroundColor: text,
            transition: "width 0.4s ease",
          }}
        />
      </div>
    </div>
  );
}
 
const PAGE_SIZE_OPTIONS = [10, 20, 50];
function PageSizeDropdown({ value, onChange, isMobile }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handleClick = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const handleKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    document.addEventListener("touchstart", handleClick);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("touchstart", handleClick);
      document.removeEventListener("keydown", handleKey);
    };
  }, [open]);

  return (
    <div ref={rootRef} style={{ position: "relative", display: "flex", alignItems: "center", gap: 8 }}>
      <span style={{ fontSize: 13, color: "#6B7280", whiteSpace: "nowrap" }}>
        Rows per page:
      </span>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          fontSize: 13,
          padding: "6px 10px",
          border: open ? "1px solid #2563EB" : "1px solid #E5E7EB",
          borderRadius: 8,
          outline: "none",
          backgroundColor: "#fff",
          color: "#374151",
          cursor: "pointer",
          minWidth: 56,
          justifyContent: "space-between",
        }}
      >
        {value}
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke={open ? "#2563EB" : "#6B7280"}
          strokeWidth="2"
          style={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.15s",
            flexShrink: 0,
          }}
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>

      {open && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 6px)",
            right: 0,
            backgroundColor: "#fff",
            border: "1px solid #E5E7EB",
            borderRadius: 10,
            boxShadow: "0 8px 24px rgba(15, 23, 42, 0.12)",
            overflow: "hidden",
            zIndex: 30,
            minWidth: 72,
          }}
        >
          {PAGE_SIZE_OPTIONS.map((opt) => (
            <button
              key={opt}
              type="button"
              onClick={() => {
                onChange(opt);
                setOpen(false);
              }}
              style={{
                display: "block",
                width: "100%",
                textAlign: "left",
                padding: isMobile ? "10px 14px" : "8px 14px",
                fontSize: 13,
                fontWeight: opt === value ? 600 : 400,
                color: opt === value ? "#2563EB" : "#374151",
                backgroundColor: opt === value ? "#EFF6FF" : "#fff",
                border: "none",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                if (opt !== value) e.currentTarget.style.backgroundColor = "#F9FAFB";
              }}
              onMouseLeave={(e) => {
                if (opt !== value) e.currentTarget.style.backgroundColor = "#fff";
              }}
            >
              {opt}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default function ChapterMastery({ data, selectedAttemptIndex }) {
  const isMobile = useIsMobile();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [sortKey, setSortKey] = useState("chapter_name");
  const [sortDir, setSortDir] = useState("asc");
  const [activeTab, setActiveTab] = useState(0);
  const tabs = data || [];
  const currentModule = tabs[activeTab];
  const chapterData = currentModule?.chapters || [];

  const grouped = useMemo(() => {
    return chapterData.map((chapter) => ({
      ...chapter,
      attempt_count: selectedAttemptIndex + 1,
    }));
  }, [chapterData, selectedAttemptIndex]);

  const filtered = useMemo(() => {
    const q = search.toLowerCase().trim();
    return grouped.filter((r) => r.chapter_name.toLowerCase().includes(q));
  }, [grouped, search]);

  const sorted = useMemo(() => {
    return [...filtered].sort((a, b) => {
      let va = a[sortKey];
      let vb = b[sortKey];
      if (typeof va === "string") va = va.toLowerCase();
      if (typeof vb === "string") vb = vb.toLowerCase();
      if (va < vb) return sortDir === "asc" ? -1 : 1;
      if (va > vb) return sortDir === "asc" ? 1 : -1;
      return 0;
    });
  }, [filtered, sortKey, sortDir]);
 
  const totalPages = Math.max(1, Math.ceil(sorted.length / pageSize));
  const safePage = Math.min(page, totalPages);
  const pageData = sorted.slice((safePage - 1) * pageSize, safePage * pageSize);

  const handleSort = (key) => {
    if (sortKey === key) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    else { setSortKey(key); setSortDir("asc"); }
    setPage(1);
  };

  const handlePageSize = (newSize) => { setPageSize(newSize); setPage(1); };

  const SortIcon = ({ col }) => {
    if (sortKey !== col) return <span style={{ color: "#CBD5E1", fontSize: 11, marginLeft: 4 }}>↕</span>;
    return <span style={{ color: "#3B82F6", fontSize: 11, marginLeft: 4 }}>{sortDir === "asc" ? "↑" : "↓"}</span>;
  };
 
  const cols = [
    { key: "chapter_name", label: "Chapter / Skill", shortLabel: "Chapter/Skill", width: isMobile ? "40%" : "45%" },
    { key: "total_questions", label: "Questions", shortLabel: "Ques", width: isMobile ? "15%" : "12%" },
    { key: "correct_answers", label: "Correct", shortLabel: "Corr", width: isMobile ? "15%" : "12%" },
    { key: "percentage", label: "Score", shortLabel: "Score", width: isMobile ? "18%" : "16%" },
    { key: "attempt_count", label: "Attempts", shortLabel: "Att", width: isMobile ? "12%" : "10%" },
  ];

  const pageNumbers = () => {
    const pages = [];
    const delta = 2;

    const left = Math.max(1, safePage - delta);
    const right = Math.min(totalPages, safePage + delta);

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= left && i <= right)) {
        pages.push(i);
      } else if (i === left - 1 || i === right + 1) {
        pages.push("...");
      }
    }

    return pages;
  };

  const rowsPerPageSelect = (
    <PageSizeDropdown value={pageSize} onChange={handlePageSize} isMobile={isMobile} />
  );

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 sm:p-6">
      <div style={{ marginBottom: 20 }}>
        <div className="flex items-start justify-between gap-3">
          <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: "#111827", letterSpacing: "-0.3px" }}>
            Your Strong & Weak Chapters
          </h2>
          <div className="sm:hidden shrink-0">
            {rowsPerPageSelect}
          </div>
        </div>
        <p style={{ margin: "4px 0 0", fontSize: 13, color: "#6B7280" }}>
          {/* Performance across all chapters — {filtered.length} chapters */}
          Find the chapters you're confident in and the ones that need more practice
        </p>
      </div>

      <div className="hidden sm:flex" style={{justifyContent: "flex-end",marginBottom: 14}}>
        {rowsPerPageSelect}
      </div>

      <div className="flex overflow-x-auto pb-2 mb-5
          [&::-webkit-scrollbar]:h-1.5
          [&::-webkit-scrollbar-track]:bg-gray-100
          [&::-webkit-scrollbar-track]:rounded-full
          [&::-webkit-scrollbar-thumb]:bg-gray-300
          [&::-webkit-scrollbar-thumb]:rounded-full"
        style={{ gap: 8, scrollbarWidth: "thin", scrollbarColor: "#D1D5DB #F3F4F6" }}
      >
        {tabs.map((module, index) => (
          <button
            key={module.module_id}
            onClick={() => setActiveTab(index)}
            style={{
              padding: isMobile ? "8px 14px" : "10px 16px",
              borderRadius: 10,
              border:
                activeTab === index
                  ? "1px solid #2563EB"
                  : "1px solid #E5E7EB",
              background:
                activeTab === index ? "#2563EB" : "#FFFFFF",
              color:
                activeTab === index ? "#FFFFFF" : "#374151",
              fontWeight: 600,
              fontSize: isMobile ? 13 : 14,
              cursor: "pointer",
              whiteSpace: "nowrap",
              flexShrink: 0,
            }}
          >
            {module.module_name}
          </button>
        ))}
      </div>

      <div style={{ border: "1px solid #E5E7EB", borderRadius: 12, overflow: "hidden", backgroundColor: "#fff" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
          <thead>
            <tr style={{ backgroundColor: "#F9FAFB", borderBottom: "1px solid #E5E7EB" }}>
              {cols.map((col) => (
                <th
                  key={col.key}
                  onClick={() => handleSort(col.key)}
                  style={{
                    width: col.width,
                    padding: isMobile ? "8px 6px" : "11px 16px",
                    textAlign: col.key === "chapter_name" ? "left" : "center",
                    fontSize: isMobile ? 10 : 12,
                    fontWeight: 600,
                    color: "#6B7280",
                    letterSpacing: "0.04em",
                    textTransform: "uppercase",
                    cursor: "pointer",
                    userSelect: "none",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {isMobile ? col.shortLabel : col.label}
                  <SortIcon col={col.key} />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {pageData.length === 0 ? (
              <tr>
                <td colSpan={5} style={{ padding: "40px 16px", textAlign: "center", color: "#9CA3AF", fontSize: 14 }}>
                  No chapters found
                </td>
              </tr>
            ) : (
              pageData.map((row, idx) => (
                <tr
                  key={row.chapter_name + idx}
                  style={{
                    borderBottom: idx < pageData.length - 1 ? "1px solid #F3F4F6" : "none",
                    transition: "background 0.15s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F9FAFB")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                >
                  <td style={{ padding: isMobile ? "10px 6px" : "13px 16px" }}>
                    <div style={{ fontSize: isMobile ? 13 : 14, fontWeight: 500, color: "#111827", marginBottom: 4, overflowWrap: "break-word" }}>
                      {row.chapter_name}
                    </div>
                    <MiniBar value={row.percentage} />
                  </td>
                  <td style={{ padding: isMobile ? "10px 6px" : "13px 16px", textAlign: "center", fontSize: isMobile ? 12 : 13, color: "#374151", fontWeight: 500 }}>
                    {row.total_questions}
                  </td>
                  <td style={{ padding: isMobile ? "10px 6px" : "13px 16px", textAlign: "center", fontSize: isMobile ? 12 : 13, color: "#374151", fontWeight: 500 }}>
                    {row.correct_answers}
                  </td>
                  <td style={{ padding: isMobile ? "10px 6px" : "13px 16px", textAlign: "center" }}>
                    <ScoreBadge value={row.percentage} compact={isMobile} />
                  </td>
                  <td style={{ padding: isMobile ? "10px 6px" : "13px 16px", textAlign: "center" }}>
                    <span style={{
                      display: "inline-flex", alignItems: "center", justifyContent: "center",
                      minWidth: isMobile ? 22 : 28, height: isMobile ? 20 : 22, borderRadius: 99,
                      backgroundColor: "#EFF6FF", color: "#2563EB",
                      fontSize: isMobile ? 11 : 12, fontWeight: 600,
                    }}>
                      {selectedAttemptIndex + 1}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
 
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 16, flexWrap: "wrap", gap: 10 }}>
        <span style={{ fontSize: 13, color: "#6B7280" }}>
          Showing {sorted.length === 0 ? 0 : (safePage - 1) * pageSize + 1}–{Math.min(safePage * pageSize, sorted.length)} of {sorted.length}
        </span>
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <button onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={safePage === 1}
            style={{
              width: 32, height: 32, borderRadius: 8, border: "1px solid #E5E7EB",
              backgroundColor: safePage === 1 ? "#F9FAFB" : "#fff",
              color: safePage === 1 ? "#D1D5DB" : "#374151",
              cursor: safePage === 1 ? "not-allowed" : "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 14, fontWeight: 500,
            }}
          >
            ‹
          </button>
 
          {pageNumbers().map((p, i) =>
            p === "..." ? (
              <span key={i} style={{ width: 32, textAlign: "center", color: "#9CA3AF", fontSize: 13 }}>…</span>
            ) : (
              <button key={i} onClick={() => setPage(p)}
                style={{
                  width: 32, height: 32, borderRadius: 8,
                  border: p === safePage ? "1.5px solid #2563EB" : "1px solid #E5E7EB",
                  backgroundColor: p === safePage ? "#2563EB" : "#fff",
                  color: p === safePage ? "#fff" : "#374151",
                  cursor: "pointer",
                  fontSize: 13, fontWeight: p === safePage ? 700 : 400,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  transition: "all 0.15s",
                }}
              >
                {p}
              </button>
            )
          )}

          <button onClick={() => setPage((p) => Math.min(totalPages, p + 1))} disabled={safePage === totalPages}
            style={{
              width: 32, height: 32, borderRadius: 8, border: "1px solid #E5E7EB",
              backgroundColor: safePage === totalPages ? "#F9FAFB" : "#fff",
              color: safePage === totalPages ? "#D1D5DB" : "#374151",
              cursor: safePage === totalPages ? "not-allowed" : "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 14, fontWeight: 500,
            }}
          >
            ›
          </button>
        </div>
      </div>
    </div>
  );
}
 